import React from 'react';
import { Stack, Button } from '@mui/material';
import AgreementTemplateForm from './AgreementTemplateForm';

export default function AddTemplate ({ setTemplates }) {
  const [open, setOpen] = React.useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <>
      <Stack justifyContent="center" alignItems="center">
        <Button variant="contained" onClick={handleOpen}>
          Dodaj szablon
        </Button>
      </Stack>
      <AgreementTemplateForm open={open} handleClose={handleClose} setTemplates={setTemplates}/>
    </>
  );

};
